import React from 'react'
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  Typography,
  Box,
  CircularProgress,
  Avatar,
  Alert
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { deployAiAgent } from '../redux/slices/DeployAIAgent';
import { useDispatch, useSelector } from 'react-redux';
function DeployAIBot({open, onClose, onDeployStart}) {
  const {deployAgentLoading, deployAgentError} = useSelector((state) => state.DeploySlice);
  const {slugName, formDetails} = useSelector((state) => state.CreateAgentSlice);
  
  const dispatch = useDispatch()

  const handleRunAIAgent = () => {
    onClose(); // Close the popup first
    onDeployStart(); // Show the deploy loader
    dispatch(deployAiAgent(slugName))
  }


  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '500px',
          margin: 'auto',
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          overflow: 'hidden'
        }
      }}
    >
      {/* Header with Icon */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 3,
          pb: 2,
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#f8f9fa'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              width: 48,
              height: 48,
              backgroundColor: '#3B5CFF',
              color: 'white'
            }}
          >
            <RocketLaunchIcon sx={{ fontSize: 24 }} />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c3e50', mb: 0.5 }}>
              Deploy Your Agent
            </Typography>
            <Typography variant="body2" sx={{ color: '#6c757d' }}>
              Ready to launch your AI agent into production
            </Typography>
          </Box>
        </Box>
        <Button 
          onClick={onClose} 
          sx={{ 
            minWidth: 'auto',
            p: 1,
            color: '#6c757d',
            '&:hover': {
              backgroundColor: '#e9ecef'
            }
          }}
        >
          <CancelOutlinedIcon fontSize="small" />
        </Button>
      </Box>

      <DialogContent sx={{ p: 3, pt: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#495057', 
              mb: 2,
              lineHeight: 1.6
            }}
          >
            Your AI agent <strong>"{formDetails?.name}"</strong> is ready to be deployed. 
            This will start the agent and make it available for processing documents.
          </Typography>
          
          <Box sx={{ 
            p: 2, 
            backgroundColor: '#e8f4fd', 
            borderRadius: '12px',
            border: '1px solid #b3d9ff'
          }}>
            <Typography variant="body2" sx={{ color: '#0066cc', fontWeight: 500 }}>
              ⚡ Deployment will start the agent immediately and begin processing any available documents.
            </Typography>
          </Box>
        </Box>

        {deployAgentError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {deployAgentError}
          </Alert>
        )}
      </DialogContent>

      <DialogActions sx={{ 
        px: 3, 
        pb: 3, 
        gap: 2,
        justifyContent: 'flex-end'
      }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={deployAgentLoading}
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1.5,
            borderColor: '#6c757d',
            color: '#6c757d',
            '&:hover': {
              borderColor: '#495057',
              backgroundColor: '#f8f9fa'
            },
            '&:disabled': {
              borderColor: '#dee2e6',
              color: '#adb5bd'
            }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleRunAIAgent}
          variant="contained"
          disabled={deployAgentLoading}
          startIcon={deployAgentLoading ? <CircularProgress size={20} color="inherit" /> : <RocketLaunchIcon />}
          sx={{
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1.5,
            backgroundColor: '#3B5CFF',
            boxShadow: '0 4px 15px rgba(59, 92, 255, 0.3)',
            '&:hover': {
              backgroundColor: '#2E4BC0',
              boxShadow: '0 6px 20px rgba(59, 92, 255, 0.4)',
              transform: 'translateY(-1px)',
            },
            '&:disabled': {
              backgroundColor: '#6c757d',
              boxShadow: 'none',
              transform: 'none'
            },
            transition: 'all 0.3s ease',
          }}
        >
          {deployAgentLoading ? 'Deploying...' : 'Deploy Agent'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeployAIBot
